module.exports = __webpack_public_path__ + "static/feature-formeditor-6a904c277cb85bf516b1f4e6f44afda2.mp4";